import posthog from 'posthog-js';

import { TrackedEvents } from '../types/events';
import { initAnalytics } from './initAnalytics';

export const trackEvent = (event: TrackedEvents, properties?: Record<string, unknown>) => {
  if (!posthog.__loaded) {
    initAnalytics();
  }
  posthog.capture(event, properties);
};
